export function slugify(str: string) {
  return str
    .trim()
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "")
    .replace(/--+/g, "-");
}

export function unslugify(str: string) {
  return str.replace(/-/g, " ");
}

export function toTitleCase(str: string) {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.slice(1).toLowerCase(),
  );
}

export function toSentenceCase(str: string) {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
}

export function getInitials(str: string) {
  return (
    str
      ?.match(/(?<=\s|^)\p{L}\p{Mn}*/gu)
      ?.filter((_, i, array) => i === 0 || i === array.length - 1)
      .join("") ?? ""
  );
}

export function getAsString(value: string | string[] | undefined): string {
  if (Array.isArray(value)) {
    return value[0]!;
  }

  return value!;
}
